import { FC, useState,ChangeEvent, useEffect, CSSProperties } from 'react';
import {BsSearch} from 'react-icons/bs';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Text, { Ecolor } from '../text';
import classes from './style.module.scss';

export type IDropDownItem = {
  name: string;
  value: string;
};

interface TDropDownProps {
  dropDownItem: Array<IDropDownItem>;
  label: string;
  value?:string[];
  type: 'single' | 'multiple';
  required?: boolean;
  className?: string;
  onSelectItem: (items: IDropDownItem[]) => void;
  searchfilter?: boolean;
  style?:CSSProperties,
  disable?:boolean
}

const Dropdown: FC<TDropDownProps> = ({
  dropDownItem = [],
  label,
  value=[],
  type,
  onSelectItem,
  required,
  className = '',
  searchfilter = false,
  style={},
  disable=false
}) => {
  // * Required State's * //
  const [options,setOptions]=useState(dropDownItem);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState<IDropDownItem[]>([]);
  const [searchText,setSearchText]=useState('');

  // * Function to handle click on single selected item's * //
  const handleClickOnSingleSelect = (_selected: IDropDownItem) => {
    onSelectItem([_selected]);
    setSelectedItems([_selected]);
    setIsOpen(false);
    if(searchfilter){
      setSearchText('');
      setOptions(dropDownItem);
    }
  };

  // * Function to handle click on single selected item's * //
  const handleClickOnMultiSelect = (_selected: IDropDownItem) => {
    onSelectItem([...selectedItems, _selected]);
    setSelectedItems([...selectedItems, _selected]);
  };
  const handelSearch=(e:ChangeEvent<HTMLInputElement>)=>{
    let val = e.target.value;
    setSearchText(val);
    if(val===''){
      setOptions(dropDownItem);
      return;
    }
    let newoptions = dropDownItem.filter((opt)=>{
      return opt.name.toLowerCase().includes(val.toLowerCase())
    });
    setOptions(newoptions);
  }
  useEffect(()=>{
    if(value.length===0){
      setSelectedItems([]);
      return;
    }
    if(type==='single'){
      for(let item of dropDownItem){
        if(value[0]===item.value){
          setSelectedItems([item]);
          break;
        }
      }
    }else{
      setSelectedItems(dropDownItem.filter(item=>{return value.indexOf(item.value)>=0?true:false}));
    }
  },[JSON.stringify(value)])
  useEffect(()=>{
    setOptions(dropDownItem);
  },[JSON.stringify(dropDownItem)])
  return (
    <div className={className ? `${className} ${classes.container}` : classes.container} style={style}>
      <div className={isOpen ? classes.overlay : classes.hide} onClick={() => { setIsOpen(false) }} ></div>
      <Text color={Ecolor.deep} required={required}>
        {label}
      </Text>
      <div
        onClick={() => {!disable && setIsOpen(!isOpen)}}
        className={classes.selectContainer}
      >
        {selectedItems.map((element, i) => {
          if (type === 'single') {
            return <div key={`select_item_${i}_${element.value}`} className={classes.selectedItem}>{element.name}</div>;
          }

          return (
            <div className={classes.multiSelectCnt}>
              <span className={classes.selectedItem}>{element.name}</span>
              <FontAwesomeIcon icon={faXmark} />
            </div>
          );
        })}
      </div>
      <div className={classes.dropDownContainer} data-isopen={isOpen}>
        {(searchfilter && isOpen) &&
          <div className={classes.searchFilter}>
            <BsSearch/>
            <input type='text' value={searchText} autoFocus={true} onChange={handelSearch} />
          </div>
        }
        {isOpen &&
          options.length > 0 &&
          options.map(
            (element: { name: string; value: string }, index: number) => {
              if (type === 'single') {
                return (
                  <div
                    key={`${index}-${element.value}`}
                    onClick={() => handleClickOnSingleSelect(element)}
                    className={classes.dropDownItme}
                  >
                    {element.name}
                  </div>
                );
              }
              return (
                <div className={classes.multiDrpDnCont}>
                  <input
                    type="checkbox"
                    value={element.value}
                    onChange={() => handleClickOnMultiSelect(element)}
                  />
                  <p className={classes.dropDownItme}>{element.name}</p>
                </div>
              );
            }
          )}
      </div>
    </div>
  );
};

export default Dropdown;
